/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { CMSFaq } from '@/features/contentstack/components/CMSFaq/CMSFaq';
import { type ContentStackFaq } from '@/features/contentstack/interface/content-types';
import { type FormattedContentStackBlogFaq } from '@/features/contentstack/interface/models';

type CMSBlogFaqProps = {
  content: FormattedContentStackBlogFaq;
};

export const CMSBlogFaq = ({ content }: CMSBlogFaqProps) => {
  const faqContent: ContentStackFaq = {
    title: content?.title ?? '',
    heading: content?.title ?? '',
    theme: 'Accordion View',
    faq: content?.faq,
  };

  return <CMSFaq content={faqContent} />;
};
